import React from 'react'

import { graphql } from '../../../../services/graphql'
import { useSynchronizeData } from '../../../../hooks/use-synchronize-data'

import { buildComponent } from '../../../../components/factory'

import * as UI from '@mantine/core'
import * as Elements from '../../../../components/elements'

export const SectionTrack = buildComponent<{
  gong: string
}>()
  .withLifecycle(({ props }) => {
    return useSynchronizeData(
      graphql.queries.getGong,
      graphql.mutations.updateGong,
      props.gong,
    )
  })
  .withRender(({ lifecycle }) => (
    <UI.Stack spacing={24}>
      <UI.Title order={3}>Piste audio</UI.Title>
      <UI.Text size="sm" color="dimmed">
        Piste audio utilisée pour ce gong.
      </UI.Text>

      <UI.Group>
        <Elements.GongAudioButton
          slug={lifecycle.data?.slug}
          entity={lifecycle.data?._id}
          /*onUpload={async () => {
            await graphql.mutations.uploadGong({
              id: lifecycle.data?._id || '',
            })
          }}*/
          onDelete={async () => {
            await graphql.mutations.uncacheGong({
              id: lifecycle.data?._id || '',
            })
          }}
        />
      </UI.Group>

      {lifecycle.loading && (
        <UI.Loader
          sx={{ position: 'absolute', top: '1rem', right: '1rem' }}
          size="xs"
        />
      )}
    </UI.Stack>
  ))
